import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

type ItemId = string | number;
type Item = {
  id: ItemId;
  [key: string]: any;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'MovableItem',
  props: {
    items: null,
    item: null,
    title: null,
    link: null
  },
  emits: ["update:items"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:items', updatedItems: Item[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  items: Item[];
  item: Item;
  title?: string;
  link?: string;
}



const panel = ref([0]);



const findIndex = (id: ItemId) => {
  return props.items.findIndex((i) => i.id === id);
};

const moveUp = (id: ItemId) => {
  const index = findIndex(id);
  if (index > 0) {
    const temp = props.items[index];
    const updatedItems = [...props.items];
    updatedItems[index] = updatedItems[index - 1];
    updatedItems[index - 1] = temp;
    emit('update:items', updatedItems);
  }
};

const moveDown = (id: ItemId) => {
  const index = findIndex(id);
  if (index < props.items.length - 1) {
    const temp = props.items[index];
    const updatedItems = [...props.items];
    updatedItems[index] = updatedItems[index + 1];
    updatedItems[index + 1] = temp;
    emit('update:items', updatedItems);
  }
};

const moveToTop = (id: ItemId) => {
  const index = findIndex(id);
  if (index > 0) {
    const updatedItems = [...props.items];
    const item = updatedItems.splice(index, 1)[0];
    updatedItems.unshift(item);
    emit('update:items', updatedItems);
  }
};

const moveToBottom = (id: ItemId) => {
  const index = findIndex(id);
  if (index < props.items.length - 1) {
    const updatedItems = [...props.items];
    const item = updatedItems.splice(index, 1)[0];
    updatedItems.push(item);
    emit('update:items', updatedItems);
  }
};

const deleteItem = (id: ItemId) => {
  const index = findIndex(id);
  const updatedItems = [...props.items];
  updatedItems.splice(index, 1);
  emit('update:items', updatedItems);
};

const navigateTo = () => {
  window.open(props.link, '_blank');
};


return { __sfc: true,props, panel, emit, findIndex, moveUp, moveDown, moveToTop, moveToBottom, deleteItem, navigateTo }
}

})